import { Box, Card, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
import WTypography from '../../../../Components/whiteTypography'

function SimpleCard({ oldData }) {
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  // const SimpleCart = [
  //   {
  //     Indicateur: "Liquidités",
  //     Valeur: "600 €",
  //   },
  //   {
  //     Indicateur: "Patrimoine",
  //     Valeur: "200 €",
  //   },
  // ];

  return (
    <Card
      style={{
        backgroundColor: theme.palette.appBar.main,
        padding: '15px',
        boxShadow: 'none',
      }}
    >
      <Box display="flex" justifyContent="space-between">
        <WTypography component={'span'} variant="h5">
          {oldData && oldData.nom}
        </WTypography>
        <WTypography component={'span'} variant="h5">
          {oldData && oldData.calculation} €
        </WTypography>
      </Box>
      {oldData && oldData.calculation === 0 && (
        <WTypography variant="h6" align="center">
          {t('finance.fiStatement.noData')}
        </WTypography>
      )}
    </Card>
  )
}

export default SimpleCard
